<!--
비밀번호 재설정
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-medium">

            <div class="uk-modal-body uk-padding-small">

                <h4><i class="material-icons">edit</i>비밀번호 재설정</h4>

                <div class="pt-1rem">
                    가입시 사용한 이메일, 핸드폰을 입력하시면, 비밀번호 재설정 알림톡이 발송됩니다.
                </div>

                <table class="info-table small uk-width-1-1">
                    <colgroup>
                        <col style="width: 6rem">
                        <col>
                    </colgroup>
                    <tbody>
                    <tr>
                        <th class="uk-text-right" @click="$refs.email.inputFocus()">
                            이메일
                        </th>
                        <td class="uk-text-center">
                            <app-input-text
                                ref="email"
                                v-model="inputs.email"
                            ></app-input-text>
                        </td>
                    </tr>
                    <tr>
                        <th class="uk-text-right" @click="$refs.cell.inputFocus()">
                            핸드폰
                        </th>
                        <td class="uk-text-center">
                            <app-input-text
                                ref="cell"
                                v-model="inputs.cell"
                            ></app-input-text>
                        </td>
                    </tr>
                    </tbody>
                </table>


                <div class="uk-text-right pt-1rem">
                    <!--- 버튼 -->
                    <button
                        type="button"
                        class="uk-button uk-button-default uk-modal-close"
                    >
                        <i class="material-icons">close</i> 취소
                    </button>

                    <button
                        type="button"
                        class="uk-button uk-button-primary"
                        @click="submit"
                    >
                        <i class="material-icons">sms</i>
                        재설정(알림톡 발송)
                    </button>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
    export default {
        props: {
            /**
             * csrf token
             */
            csrfToken: {
                type: String,
                required: true,
            },


        },
        data: function () {
            return {

                /**
                 * (object) 입력값
                 */
                inputs: {
                    email: null,
                    cell: null,
                },


            };
        },
        computed: {

        },
        methods: {
            /**
             * 입력폼 display
             */
            show() {
                UIkit.modal(this.$el).show();
            },
            hide() {
                UIkit.modal(this.$el).hide();
            },

            /**
             * 폼
             * @param email
             * @param cell
             */
            form(email, cell) {

                // 입력값 초기화
                if (email) {
                    this.inputs.email = email;
                }
                if (cell) {
                    this.inputs.cell = cell;
                }

                // 폼띄우기
                this.show();
            },

            /**
             * submit
             */
            submit() {
                // ajax 옵션
                let opts = {
                    type: 'post',
                    url: '/password/email',
                    data: _.merge({
                        '_token': this.csrfToken,
                    }, this.inputs),
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(() => {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>